const FULL_STORY_ORG_ID = '18266V';
export { FULL_STORY_ORG_ID };

//# sourceMappingURL=full-story.js.map